// Jeux de couleurs des chips liés à l'import bancaire, au format RECURRENCE_KINDS.

export const LABEL_STATUS_KINDS = {
  confirmed: { label: 'Confirmé', color: '#86efac', bg: 'rgba(134,239,172,0.10)', border: 'rgba(134,239,172,0.28)' },
  rule: { label: 'Règle', color: '#a5b4fc', bg: 'rgba(165,180,252,0.12)', border: 'rgba(165,180,252,0.30)' },
  classifier: { label: 'Appris', color: '#c4b5fd', bg: 'rgba(196,181,253,0.12)', border: 'rgba(196,181,253,0.30)' },
  llm: { label: 'Claude · à vérifier', color: '#fde047', bg: 'rgba(253,224,71,0.10)', border: 'rgba(253,224,71,0.30)' },
  unmatched: { label: 'Inconnu · à vérifier', color: '#fca5a5', bg: 'rgba(252,165,165,0.10)', border: 'rgba(252,165,165,0.30)' },
};

export const IMPORT_ACTION_KINDS = {
  create: { label: 'Nouvelle', color: '#86efac', bg: 'rgba(134,239,172,0.10)', border: 'rgba(134,239,172,0.28)' },
  matched: { label: 'Rapprochée', color: '#a5b4fc', bg: 'rgba(165,180,252,0.12)', border: 'rgba(165,180,252,0.30)' },
  recurring: { label: 'Récurrentes', color: '#c4b5fd', bg: 'rgba(196,181,253,0.12)', border: 'rgba(196,181,253,0.30)' },
  duplicate: { label: 'Déjà importée', color: '#6b6b76', bg: 'rgba(255,255,255,0.04)', border: 'rgba(255,255,255,0.08)' },
};

export const RULE_ORIGIN_KINDS = {
  user: { label: 'Toi', color: '#86efac', bg: 'rgba(134,239,172,0.10)', border: 'rgba(134,239,172,0.28)' },
  learned: { label: 'Appris', color: '#c4b5fd', bg: 'rgba(196,181,253,0.12)', border: 'rgba(196,181,253,0.30)' },
  llm: { label: 'Claude', color: '#fde047', bg: 'rgba(253,224,71,0.10)', border: 'rgba(253,224,71,0.30)' },
};

/** Statuts qui méritent l'attention de l'utilisateur. */
export const REVIEW_STATUSES = new Set(['llm', 'unmatched']);

export function isBankSourced(tx) {
  return tx?.source === 'csv' || tx?.source === 'bank';
}

export function needsReview(tx) {
  return REVIEW_STATUSES.has(tx?.labelStatus);
}
